import { ETAT_RECEPTIONNE } from '@/configuration/logistique/demandeImpression/demandeImpressionConf';

export default function genererDemandeImpression() {
  return {
    dateDemande: null,
    societeId: null,
    etat: ETAT_RECEPTIONNE,
    clientId: null,
    client: null,
    contactDemandeurId: null,
    contactReceveurId: null,
    dispositifId: null,
    dispositif: null,
    commentaire: '',
    quantite: null,
    campagneId: null,
    couleur: null,
    nomVariante: '',
    dateLimite: null,
    description: '',
    tags: [],
    typeOtId: null,
  };
}
